module.exports = __webpack_public_path__ + "static/media/finishing-overview.b853e25f.svg";